import { useContext } from 'react';
import { useSearchParams } from 'react-router';

import { resolveReturnUrl } from '../../logic/resolveReturnUrl';
import { ReturnUrlContext } from '../../ReturnUrlContext';

export const useResolveReturnUrl = (
  loginPath: string,
  adminPath: string,
  authPath?: string,
  pathsToIgnore: readonly string[] = [],
): ((currentUserSub: string | undefined) => string) => {
  const [searchParams] = useSearchParams();
  const { returnUrl: contextFallback, returnUrlOwner } =
    useContext(ReturnUrlContext);

  const queryReturnUrl = searchParams.get('returnUrl');
  const stored =
    queryReturnUrl !== null
      ? { url: queryReturnUrl, owner: searchParams.get('owner') ?? undefined }
      : { url: contextFallback, owner: returnUrlOwner };

  return (currentUserSub: string | undefined) =>
    resolveReturnUrl(
      stored,
      currentUserSub,
      loginPath,
      adminPath,
      authPath,
      pathsToIgnore,
    );
};
